module.exports = __webpack_public_path__ + "img/search_icon.19254a42.svg";